import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import { UploadInvoiceActionContext } from "./UploadInvoiceActionContext";
import {getApi} from "@beeldit/core/helpers/api";

function useUploadInvoice() {
  const { elementId, element, setShowModal, setBackendFormErrors } = useContext(UploadInvoiceActionContext);
  const errorHandler = useErrorHandler();
  const formData = new FormData();
  if (element && element.file) {
      const file = base64ToFile(element.file); // Convertir base64 a File

      formData.append("file", file);
  }
  const config = {
    headers: {
        "Content-Type": "multipart/form-data",
    },
  };
  return (onSuccess: any) => {
      getApi().post(`/orders/upload-invoice/${elementId}`, formData, config)
      .then((response: any) => {
        setShowModal(false);
        onSuccess();
      })
      .catch((error: any) => {
        errorHandler(error, setBackendFormErrors);
      });
  };
}

const base64ToFile = (dataUrl: string) => {
    const arr = dataUrl.split(",");
    const meta = arr[0];
    const b64 = arr[1];

    // Extraer el MIME type
    const mimeMatch = meta.match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "application/octet-stream";

    // Extraer el nombre del archivo si está presente
    const nameMatch = meta.match(/name=([^;]+)/);
    const fileName = nameMatch ? nameMatch[1] : "archivo.pdf"; // Default si no hay nombre

    // Convertir Base64 a Blob
    const bstr = atob(b64);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], fileName, { type: mime });
};

export default useUploadInvoice;
